import { createReducer } from 'typesafe-actions'
import { Reducer } from 'redux'
import {
  ConfigurationLogoAction,
  ConfigurationLogoTypes,
  ConfigurationLogoState,
} from '../types'

export const initState: ConfigurationLogoState = {
  isFetching: false,
  content: false,
  contentHeader: false
}
export const configurationLogoReducer: Reducer<
  ConfigurationLogoState
> = createReducer<ConfigurationLogoState, ConfigurationLogoAction>(initState, {
  [ConfigurationLogoTypes.CONFIGURATION_LOGO_REQUEST]: (
    state: ConfigurationLogoState
  ) => ({
    ...state,
    isFetching: true
    // data: { content: [], size: 0 }
  }),
  [ConfigurationLogoTypes.CONFIGURATION_LOGO_SUCCESS]: (
    state: ConfigurationLogoState,
    action
  ) => ({
    ...state,
    isFetching: false,
    content: action.payload
  }),
  [ConfigurationLogoTypes.CONFIGURATION_LOGO_FAIL]: (
    state: ConfigurationLogoState
  ) => ({
    ...state,
    isFetching: false
  }),
  [ConfigurationLogoTypes.CONFIGURATION_LOGO_HEADER_REQUEST]: (
      state: ConfigurationLogoState
    ) => ({
      ...state,
      isFetching: true
      // data: { content: [], size: 0 }
    }),
    [ConfigurationLogoTypes.CONFIGURATION_LOGO_HEADER_SUCCESS]: (
      state: ConfigurationLogoState,
      action
    ) => ({
      ...state,
      isFetching: false,
      contentHeader: action.payload
    }),
    [ConfigurationLogoTypes.CONFIGURATION_LOGO_HEADER_FAIL]: (
      state: ConfigurationLogoState
    ) => ({
      ...state,
      isFetching: false
    })
})

export default configurationLogoReducer
